import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/announcement`;

const getAnnouncements = async () => {
  return await axios.get(API_URL);
};

const getUnreadCount = async () => {
  return await axios.get(`${API_URL}/unread-count`);
};

const getAnnouncement = async (id) => {
  return await axios.get(`${API_URL}/${id}`);
};

/** Create announcement with explicit status ('published' | 'draft' | 'hidden') */
const createAnnouncement = async (data) => {
  return await axios.post(API_URL, { status: 'published', ...data });
};

/** Create without notifying — sets status: 'draft' */
const createDraft = async (data) => {
  return await axios.post(API_URL, { ...data, status: 'draft' });
};

const updateAnnouncement = async (id, data) => {
  return await axios.put(`${API_URL}/${id}`, data);
};

/** Change status of an existing announcement */
const setStatus = async (id, status) => {
  return await axios.put(`${API_URL}/${id}`, { status });
};

const deleteAnnouncement = async (id) => {
  return await axios.delete(`${API_URL}/${id}`);
};

const markAnnouncementRead = async (id, readDurationSeconds, pin = false) => {
  return await axios.post(`${API_URL}/${id}/read`, { readDurationSeconds, pin });
};

/** Pin/unpin an announcement for the current user only (requires รับทราบ first) */
const pinAnnouncement = async (id, pinned) => {
  return await axios.post(`${API_URL}/${id}/pin`, { pinned });
};

const getComments = async (announcementId) => {
  return await axios.get(`${API_URL}/${announcementId}/comments`);
};

const createComment = async (announcementId, content, imageFiles = []) => {
  if (imageFiles.length > 0) {
    const formData = new FormData();
    formData.append('content', content);
    imageFiles.forEach(file => formData.append('images', file));
    return await axios.post(`${API_URL}/${announcementId}/comments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  return await axios.post(`${API_URL}/${announcementId}/comments`, { content });
};

const deleteComment = async (announcementId, commentId) => {
  return await axios.delete(`${API_URL}/${announcementId}/comments/${commentId}`);
};

const getReadStats = async (announcementId) => {
  return await axios.get(`${API_URL}/${announcementId}/read-stats`);
};

const AnnouncementService = {
  getAnnouncements,
  getUnreadCount,
  getAnnouncement,
  createAnnouncement,
  createDraft,
  updateAnnouncement,
  setStatus,
  deleteAnnouncement,
  markAnnouncementRead,
  pinAnnouncement,
  getComments,
  createComment,
  deleteComment,
  getReadStats
};

export default AnnouncementService;
